import { render, staticRenderFns } from "./DataAlertsCards.vue?vue&type=template&id=c6e38496&scoped=true&"
import script from "./DataAlertsCards.vue?vue&type=script&lang=js&"
export * from "./DataAlertsCards.vue?vue&type=script&lang=js&"
import style0 from "./DataAlertsCards.vue?vue&type=style&index=0&id=c6e38496&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e38496",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCol,VRow,VSkeletonLoader})
